<template>
    <Layout style="height: 100%" class="main">
        <div class="lock-screen-back"></div>
        <Sider hide-trigger collapsible :width="210" :collapsed-width="64" v-model="collapsed">
            <side-menu accordion :active-name="$route.name" :collapsed="collapsed" @on-select="turnToPage"
                       :menu-list="menuList">
                <!-- 需要放在菜单上面的内容，如Logo，写在side-menu标签内部，如下 -->
                <div class="logo-con">
                     <img v-show="!collapsed" src="@/assets/images/logo.png" key="max-logo"/>
                     <img v-show="collapsed" src="@/assets/images/logo-min.png" key="min-logo"/>
                 </div>
            </side-menu>
        </Sider>
        <Layout>
            <Header class="header-con">
                <header-bar :collapsed="collapsed" @on-collapsed-change="handleCollapsedChange"/>
            </Header>
            <Content>
                <Layout>
                    <div class="tag-nav-wrapper">
                        <tags-nav :value="$route" @input="handleClick" :list="tagNavList" @on-close="handleCloseTag"/>
                    </div>
                    <Content>
                        <div style="margin:20px 20px;">
                            <keep-alive :include="cacheList">
                                <router-view/>
                            </keep-alive>
                        </div>
                    </Content>
                </Layout>
            </Content>
        </Layout>
    </Layout>
</template>
<script>
import sideMenu from './side-menu/side-menu.vue';
import headerBar from './header-bar/header-bar.vue';
import tagsNav from './tags-nav/tags-nav.vue';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

export default {
    name: 'Main',
    components: {
        sideMenu,
        headerBar,
        tagsNav,
    },
    data() {
        return {
            collapsed: false,
        };
    },
    computed: {
        ...mapState('app', ['tagNavList', ',tagRouter']),
        ...mapGetters('app', ['menuList']),
        cacheList() {
            const result = this.tagNavList.filter(item => item.meta.isCache).map(item => {
                return item.name;
                /*const arr = item.name.split('_');
                if (arr.length === 1) return arr[0];
                let result = arr[0];
                for (let index = 1; index < arr.length; index++) {
                    result += arr[index].substring(0, 1).toUpperCase() + arr[index].substring(1);
                }
                return result;*/
            });
            //console.log(result);
            return result;
        },
    },
    methods: {
        ...mapMutations('app', ['setBreadCrumb', 'removeTag', 'addTag']),
        ...mapActions('user', ['handleLogin']),
        turnToPage(name, id) {
            if (id === undefined) {
                this.$router.push({ name: name });
            } else {
                this.$router.push({ name: name, params: { id: id } });
            }
        },
        handleCollapsedChange(state) {
            this.collapsed = state;
        },
        handleCloseTag(res, nextTag) {
            this.removeTag(res);
            if (this.tagNavList.length === 1) {
                this.turnToPage('home');
            } else if (nextTag !== undefined) {
                this.turnToPage(nextTag.name,nextTag.meta.id);
            }
        },
        handleClick(item) {
            this.turnToPage(item.name, item.meta.id);
        },
    },
    watch: {
        $route(newRoute) {
            this.setBreadCrumb(newRoute.matched);
            newRoute.meta.id = this.$route.params.id;

            // tag列表没有的话就新加入
            if (this.tagNavList.every(tag => tag.name !== newRoute.name)) {
                //console.log('---->' + newRoute.name);
                this.addTag(newRoute);
            }
        },
    },
    mounted() {
        // @description 初始化设置面包屑导航
        this.setBreadCrumb(this.$route.matched);
    },
};
</script>
<style lang="less">
.lock-screen-back {
    border-radius: 50%;
    z-index: -1;
    box-shadow: 0 0 0 0 #667aa6 inset;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: all 2s;
    width: 3000px;
    height: 3000px;
}

.main {
    .logo-con {
        height: 64px;
        padding: 10px;
        img {
            height: 44px;
            width: auto;
            display: block;
            margin: 0 auto;
        }
    }
    .header-con {
        background: #fff;
        padding: 0 20px;
    }
    .tag-nav-wrapper {
        padding: 0;
        height: 40px;
        background: #f0f0f0;
        overflow: hidden;
    }
    .margin-top-10 {
        margin-top: 10px;
    }
    .margin-bottom-10 {
        margin-bottom: 10px;
    }
    i {
        font-size: 16px;
    }
}
</style>
